/**
 * Import Vue
 */
import Vue from 'vue';


/**
 * Import VueX
 */
// import store from './vuex/store';


/**
 * Import and use VueRouter
 */
import VueRouter from 'vue-router';
Vue.use(VueRouter);


/**
 * Import component
 */
import CustomersMainComponent from "../components/CustomersMainComponent";
import HomePageComponent from "../components/pages/HomePageComponent";
import NewsPageComponent from "../components/pages/NewsPageComponent";
import NewsDetailPageComponent from "../components/pages/NewsDetailPageComponent";
import RecruitmentPageComponent from "../components/pages/RecruitmentPageComponent";
import ContactPageComponent from "../components/pages/ContactPageComponent";
import ProvisionComponent from "../components/pages/ProvisionComponent";
import SecurityComponent from "../components/pages/SecurityComponent";
import Error404Component from "../components/pages/errors/Error404Component";


/**
 * Define routes list
 */
const routes = [
  {
    path: '',
    component: CustomersMainComponent,
    children: [
      {
        path: '/',
        name: 'HomePageComponent',
        component: HomePageComponent
      },

      {
        path: '/tin-tuc',
        name: 'NewsPageComponent',
        component: NewsPageComponent
      },

      {
        path: '/tin-tuc/:slug',
        name: 'NewsDetailPageComponent',
        component: NewsDetailPageComponent
      },

      {
        path: '/tuyen-dung',
        name: 'RecruitmentPageComponent',
        component: RecruitmentPageComponent
      },

      {
        path: '/lien-he',
        name: 'ContactPageComponent',
        component: ContactPageComponent
      },

      {
        path: '/dieu-khoan',
        name: 'ProvisionComponent',
        component: ProvisionComponent
      },

      {
        path: '/bao-mat',
        name: 'SecurityComponent',
        component: SecurityComponent
      },
    ]
  },

  {
    path: '*',
    name: 'Error404Component',
    component: Error404Component
  }
];


/**
 * Create router instance
 * @type {VueRouter}
 */
const router = new VueRouter({
  routes,
  mode: 'history',
  linkActiveClass: 'active'
});


/**
 * Export router
 */
export default router;
